import React, { FC } from 'react';
import classNames from 'classnames';
import { HeaderLogoImage } from './logo/HeaderLogoImage';
import { HeaderLogoTitle } from './logo/HeaderLogoTitle';
import styles from './header_doctrine_logo.module.scss';

type Props = {
  loggedIn: boolean;
};

export const HeaderDoctrineLogo: FC<Props> = ({ loggedIn }) => (
  <>
    <HeaderLogoImage />
    <span
      className={classNames(styles.wrapper, {
        [styles.hideOnMobile]: !loggedIn,
      })}
    >
      <HeaderLogoTitle />
    </span>
  </>
);
